import { atom } from "recoil";

export const titleAtoms = atom({
    default: "Dashboard",
    key: "titleAtoms",
});
